module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 11-02-01-885.6ddf6767.mp4";